var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('msg',{attrs:{"position":"right","avatar":_vm.subUserInfo?.headImage || _vm.myAvatar,"content":_vm.MsgInfo.send_msg,"rightObj":_vm.MsgInfo}}),_c('msg',{attrs:{"position":"left","avatar":_vm.gptAvatar,"content":_vm.MsgInfo.receive_msg,"MsgInfo":_vm.MsgInfo,"isSendFlag":_vm.isSendFlag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }